import React from 'react'
import { Drawer, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Bar } from 'react-chartjs-2'
import isEmpty from 'lodash/isEmpty'
import { DB_DARKBLUE, DB_PURPLE, GLACIER, PURPLE } from 'constants/colors'
import { SITE_TYPE_SEAWATER } from 'constants/index'
import ProfileHelper from 'helpers/profile'
import messages from '../translate'

function Diagram({
  intl: { formatMessage },
  isFormOpened,
  tableData,
  siteType,
}) {
  const { graphs } = tableData.toJS()

  const renderChart = () => {
    let {
      predictedFeedConsumption,
      predictedSales,
      userProjectedFeedConsumption,
      userProjectedSales,
    } = graphs

    if (predictedSales.length > 12) {
      predictedFeedConsumption =
        predictedFeedConsumption &&
        predictedFeedConsumption.slice(
          Math.max(predictedFeedConsumption.length - 12, 1),
        )
      predictedSales =
        predictedSales &&
        predictedSales.slice(Math.max(predictedSales.length - 12, 1))
      userProjectedFeedConsumption =
        userProjectedFeedConsumption &&
        userProjectedFeedConsumption.slice(
          Math.max(userProjectedFeedConsumption.length - 12, 1),
        )
      userProjectedSales =
        userProjectedSales &&
        userProjectedSales.slice(Math.max(userProjectedSales.length - 12, 1))
    }

    const seawaterSiteChartData = {
      labels: predictedSales && predictedSales.map(({ x }) => x),
      datasets: [
        {
          type: 'line',
          fill: false,
          label: formatMessage(messages.predictedSales),
          borderColor: PURPLE,
          datalabels: {
            display: false,
          },
          data: (predictedSales && predictedSales.map(({ y }) => y)) || [],
        },
        {
          type: 'line',
          fill: false,
          borderDash: [5, 5],
          label: formatMessage(messages.userProjectedSales),
          borderColor: DB_PURPLE,
          datalabels: {
            display: false,
          },
          data:
            (userProjectedSales && userProjectedSales.map(({ y }) => y)) || [],
        },
        {
          label: formatMessage(messages.predictedFeedConsumption),
          backgroundColor: DB_DARKBLUE,
          datalabels: {
            display: false,
          },
          data:
            (predictedFeedConsumption &&
              predictedFeedConsumption.map(({ y }) => y)) ||
            [],
        },
        {
          label: formatMessage(messages.userProjectedFeedConsumption),
          backgroundColor: GLACIER,
          datalabels: {
            display: false,
          },
          data:
            (userProjectedFeedConsumption &&
              userProjectedFeedConsumption.map(({ y }) => y)) ||
            [],
        },
      ],
    }
    const freshwaterClientChartData = {
      labels: predictedSales && predictedSales.map(({ x }) => x),
      datasets: [
        {
          type: 'line',
          fill: false,
          label: formatMessage(messages.predictedSales),
          borderColor: PURPLE,
          datalabels: {
            display: false,
          },
          data: (predictedSales && predictedSales.map(({ y }) => y)) || [],
        },
        {
          type: 'line',
          fill: false,
          borderDash: [5, 5],
          label: formatMessage(messages.userProjectedSales),
          borderColor: DB_PURPLE,
          datalabels: {
            display: false,
          },
          data:
            (userProjectedSales && userProjectedSales.map(({ y }) => y)) || [],
        },
      ],
    }

    const chartData =
      siteType === SITE_TYPE_SEAWATER
        ? seawaterSiteChartData
        : freshwaterClientChartData
    const { code: currentCode } = ProfileHelper.getCurrentLocale()

    const chartOptions = {
      legend: {
        position: 'bottom',
      },
      tooltips: {
        callbacks: {
          label: ({ datasetIndex, yLabel: value }, { datasets }) =>
            `${datasets[datasetIndex].label}: ${
              typeof value === 'number'
                ? value.toLocaleString(currentCode)
                : value
            }`,
        },
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              callback(value) {
                if (typeof value === 'number') {
                  return value.toLocaleString(currentCode)
                }

                return value
              },
            },
          },
        ],
        xAxes: [
          {
            ticks: {
              maxTicksLimit: 12,
            },
          },
        ],
      },
    }

    return <Bar data={chartData} options={chartOptions} height={300} />
  }

  return (
    <Drawer
      className="diagram-panel projected-sites-manager-form"
      variant="persistent"
      anchor="right"
      open={isFormOpened}
      classes={{
        paper: 'info-panel-paper',
      }}>
      <div className="info-panel-header">
        <Typography className="info-title" variant="subtitle1">
          {formatMessage(messages.chart)}
        </Typography>
      </div>
      {!isEmpty(graphs) && renderChart()}
    </Drawer>
  )
}

export default connect(state => ({
  tableData: state.getIn(['projectedSitesManager', 'singleItemTableData']),
}))(injectIntl(Diagram))
